<template>
  <div>
    <div class="item-linew">下发对象及费用额度标准</div>
    <div class="budgetBox">
      <div style="padding-top: 10px;">
        <vxe-button v-waves :loading="btnLoading" status="primary" @click="goDistributorList">添加</vxe-button>
        <vxe-button v-waves status="danger" @click="deleteOjb">删除</vxe-button>
        <vxe-button v-waves style="background: #40bef8; border: 0px" status="primary" @click="modelTable.data[0] ? (batchInputShow = true) : $message.error('数据为空！')">
          批量输入
        </vxe-button>
        <vxe-button status="primary" @click="uploadFun">导入</vxe-button>
      </div>
      <div>
        <el-form ref="OBform" :model="modelTable" label-width="14px">
          <vxe-table
            border
            align="center"
            show-header-overflow
            show-overflow
            :loading="loading1"
            class="mytable-scrollbar tableOvf"
            :column-config="{ resizable: true }"
            stripe
            round
            style="margin-top: 10px"
            :max-height="$store.state.app.height - 300 > 200 ? $store.state.app.height - 200 : 200"
            :scroll-y="{ enabled: false }"
            :row-config="{ isHover: true }"
            :data="tableData1"
            :checkbox-config="OutSelectable"
            @checkbox-change="handleSelectionChange"
            @checkbox-all="handleSelectionChange"
          >
            <vxe-column type="checkbox" width="60" align="center" />
            <vxe-column type="seq" title="序号" width="60" align="center" />
            <!-- <vxe-column title="经销商id" width="80" field="dealerId" /> -->
            <vxe-column title="经理部" width="160" field="sectorName" />
            <vxe-column title="经销商名称" field="dealerName" />
            <!-- <vxe-column title="地址" width="120" field="address" /> -->
            <vxe-column title="费用额度(元)">
              <template #default="scope">
                <el-form-item label=" " :prop="'data.' + (scope.seq - 1) + '.feeLimit'" :rules="[{ required: true, message: '请输入费用额度!', trigger: 'blur' }]">
                  <a-input v-model="scope.row.feeLimit" placeholder="请输入" oninput="value=value.replace(/\D/g, '')" />
                </el-form-item>
              </template>
            </vxe-column>
            <vxe-column title="核销比例(%)">
              <template scope="scope">
                <el-form-item label=" " :prop="'data.' + (scope.seq - 1) + '.writeRate'" :rules="[{ required: true, message: '请输入核销比例!', trigger: 'blur' }]">
                  <a-input v-model="scope.row.writeRate" placeholder="请输入" @input="handleInput(scope.row, 'writeRate')" />
                </el-form-item>
              </template>
            </vxe-column>
            <vxe-column title="执行频次">
              <template scope="scope">
                <el-form-item label=" " :prop="'data.' + (scope.seq - 1) + '.executeFreq'" :rules="[{ required: true, message: '请输入执行频次!', trigger: 'blur' }]">
                  <a-input v-model="scope.row.executeFreq" placeholder="请输入" @input="v => (scope.row.executeFreq = v.replace(/[^\d]/g, ''))" />
                </el-form-item>
              </template>
            </vxe-column>
            <!-- <vxe-column title="集客目标" width="110">
              <template scope="scope">
                <el-form-item label=" ">
                  <a-input v-model="scope.row.customerTarget" placeholder="请输入" @input="v => (scope.row.customerTarget = v.replace(/[^\d]/g, ''))" />
                </el-form-item>
              </template>
            </vxe-column>
            <vxe-column title="订单目标" width="110">
              <template scope="scope">
                <el-form-item label=" ">
                  <a-input v-model="scope.row.orderTarget" placeholder="请输入" @input="v => (scope.row.orderTarget = v.replace(/[^\d]/g, ''))" />
                </el-form-item>
              </template>
            </vxe-column>
            <vxe-column title="执行数量" width="110">
              <template scope="scope">
                <el-form-item label=" ">
                  <a-input v-model="scope.row.executeNum" placeholder="请输入" @input="v => (scope.row.executeNum = v.replace(/[^\d]/g, ''))" />
                </el-form-item>
              </template>
            </vxe-column>
            <vxe-column title="关闭时间" width="160">
              <template scope="scope">
                <el-form-item label=" ">
                  <el-date-picker
                    v-model="scope.row.closeTime"
                    style="width: 130px;"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择时间"
                  />
                </el-form-item>
              </template>
            </vxe-column> -->
          </vxe-table>
        </el-form>
        <vxe-pager
          :loading="loading1"
          :current-page="tablePage1.currentPage"
          :page-size="tablePage1.pageSize"
          :total="tablePage1.totalResult"
          :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
          @page-change="handlePageChange1"
        />
      </div>
      <!--    选择经销商列表-->
      <el-dialog title="选择经销商列表" :visible.sync="showCHD" width="80%" :before-close="back1">
        <div class="usereq">
          <div>
            <el-form :inline="true" style="margin: 0px; height: auto; padding: 0px 10px; vertical-align: middle">
              <SiftDealer :base="base">
                <template slot="ButtonTwo">
                  <el-form-item style="margin: 10px">
                    <vxe-button style="background: #1b81ef; border: 0px" status="primary"  @click="queryByPage1(1)">搜索</vxe-button>
                    <vxe-button  @click="clearData1">重置</vxe-button>
                  </el-form-item>
                </template>
              </SiftDealer>
              <vxe-button v-if="false" type="primary" @click="exportFun">导出经销商</vxe-button>
            </el-form>
          </div>
          <a-row :gutter="1">
            <a-col :span="12">
              <div class="left_content">
                <vxe-table
                  ref="table1"
                  v-loading="modelTable.loading"
                  border
                  class="mytable-scrollbar"
                  show-header-overflow
                  show-overflow
                  :column-config="{ resizable: true }"
                  stripe
                  round
                  style="margin-top: 10px"
                  max-height="370"
                  :scroll-y="{ enabled: false }"
                  :row-config="{ isHover: true }"
                  :data="equipmentInfo"
                  :checkbox-config="selectable"
                  @checkbox-change="handleCheckedLeftChange($event.records)"
                  @checkbox-all="handleCheckedLeftChange($event.records)"
                >
                  <vxe-column type="checkbox" width="60" align="center" />
                  <vxe-column type="seq" title="序号" width="60" align="center" />
                  <!-- <vxe-column title="经销商id" width="80" field="dealerId" /> -->
                  <vxe-column title="经理部" field="sectorName" width="100" />
                  <vxe-column title="经销商名称" field="dealerName"/>
                  <!-- <vxe-column title="地址" field="address" width="200" /> -->
                </vxe-table>
                <!-- <vxe-pager
                  style="margin-top: 10px;"
                  :current-page="pagination1.currentPage"
                  :page-size="pagination1.pageSize"
                  :total="pagination1.total"
                  :page-sizes="[10, 50, 100, 1000]"
                  :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
                  @page-change="changePage1"
                /> -->
              </div>
            </a-col>
            <a-col :span="1">
              <div class="move-btn-container">
                <vxe-button type="primary" icon="el-icon-arrow-right" circle @click="PutDataToRight()" />
                <vxe-button style="margin: 20px 0 0 0" type="primary" icon="el-icon-arrow-left" circle @click="PutDataToLeft()" />
              </div>
            </a-col>
            <a-col :span="11">
              <div class="left_content">
                <vxe-table
                  ref="table2"
                  v-loading="modelTable.loading"
                  border
                  class="mytable-scrollbar"
                  show-header-overflow
                  show-overflow
                  :column-config="{ resizable: true }"
                  stripe
                  round
                  style="margin-top: 10px"
                  max-height="370"
                  :scroll-y="{ enabled: false }"
                  :row-config="{ isHover: true }"
                  :data="requipmentInfo"
                  @checkbox-change="rhandleCheckedLeftChange($event.records)"
                  @checkbox-all="rhandleCheckedLeftChange($event.records)"
                >
                  <vxe-column type="checkbox" width="60" align="center" />
                  <vxe-column type="seq" title="序号" width="60" align="center" />
                  <!-- <vxe-column title="经销商id" width="80" field="dealerId" /> -->
                  <vxe-column title="经理部" field="sectorName" width="100" />
                  <vxe-column title="经销商名称" field="dealerName" />
                  <!-- <vxe-column title="地址" field="address" width="200" /> -->
                </vxe-table>
              </div>
            </a-col>
          </a-row>
          <div class="footer-btn-box">
            <vxe-button @click="back1">关闭</vxe-button>
            <vxe-button status="primary" @click="submit1">确认</vxe-button>
          </div>
        </div>
      </el-dialog>
      <!-- 批量输入 -->
      <a-modal title="批量输入" :visible.sync="batchInputShow" width="35%" closable destroyOnClose @cancel="() => batchInputShow = false">
        <el-form ref="batchInputF" :inline="true" :model="batchData" class="UniformCss" label-width="120px">
          <a-row>
            <a-col>
              <el-form-item label="费用额度(元):" prop="feeLimit" :rules="[{ required: true, message: '请输入费用额度(元)!', trigger: 'blur' }]">
                <a-input v-model="batchData.feeLimit"  oninput="value=value.replace(/\D/g, '')" />
              </el-form-item>
            </a-col>
            <a-col>
              <el-form-item label="核销比例(%):" prop="writeRate" :rules="[{ required: true, message: '请输入核销比例!', trigger: 'blur' }]">
                <a-input v-model="batchData.writeRate" @input="handleInput(batchData, 'writeRate')" />
              </el-form-item>
            </a-col>
            <a-col>
              <el-form-item label="执行频次:" prop="executeFreq" :rules="[{ required: true, message: '请输入频次!', trigger: 'blur' }]">
                <a-input v-model="batchData.executeFreq" oninput="value=value.replace(/[^\d]/g, '')" />
              </el-form-item>
            </a-col>
            <!-- <a-col>
              <el-form-item label="集客目标:">
                <a-input v-model="batchData.customerTarget" oninput="value=value.replace(/[^\d]/g, '')" />
              </el-form-item>
            </a-col>
            <a-col>
              <el-form-item label="订单目标:">
                <a-input v-model="batchData.orderTarget" oninput="value=value.replace(/[^\d]/g, '')" />
              </el-form-item>
            </a-col>
            <a-col>
              <el-form-item label="执行数量:">
                <a-input v-model="batchData.executeNum" oninput="value=value.replace(/[^\d]/g, '')" />
              </el-form-item>
            </a-col>
            <a-col>
              <el-form-item label="关闭时间:">
                <a-date-picker
                  v-model="batchData.closeTime"
                  type="date"
                  :format="'YYYY-MM-DD'"
                  :value-format="'YYYY-MM-DD'"
                  placeholder="选择时间"
                />
              </el-form-item>
            </a-col> -->
          </a-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <vxe-button @click="batchInputShow = false">取 消</vxe-button>
          <vxe-button status="primary" @click="batchInputFun">确 定</vxe-button>
        </span>
      </a-modal>
      <!--导入对话框 -->
      <el-dialog title="导入Excel" :visible.sync="uploadDialog" width="400px">
        <div v-loading="importLoading" class="faultAdd">
          <div class="model-box">
            <!-- <a class="load-buttom" href="/file/活动下发对象导入模板v2.xlsx" download><i class="el-icon-download" />下载示例模板</a> -->
            <a class="load-buttom" @click="downloadTemplate"><i class="el-icon-download" />下载示例模板</a>
          </div>
          <el-upload ref="upload" class="upload-demo" drag action="" multiple :http-request="upload" :before-upload="uploadBefore" :file-list="fileList">
            <i class="el-icon-upload" />
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div slot="tip" class="el-upload__tip">直接导入已填好的Excel列表，仅支持XLS/XLSX</div>
          </el-upload>
          <div v-if="errorList.length > 0" class="err-box">
            <el-link icon="el-icon-warning" type="danger">Excel导入出错，请检查错误行，然后将错误行重新导入</el-link>
            <div v-for="item in errorList" :key="item.row">
              <el-link type="danger">第{{ item.row }}行{{ item.error }}</el-link>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import waves from '@/directive/waves' // waves directive
import { findPlanDealers, deleteDealers, uploadPlanDealer, exportDealer, exportActPlanTemp } from '@/api/actPlan'
import { findDealerList } from '@/api/base-data'
import SiftDealer from './SiftDealer.vue'
export default {
  components: { SiftDealer },
  directives: { waves },
  // eslint-disable-next-line vue/require-prop-types
  props: ['modelTable', 'actPlan'],
  data() {
    return {
      batchData: {},
      btnLoading: false,
      batchInputShow: false,
      dialog: {
        visiable: false,
        export: false
      },
      loading1: false,
      tableData1: [],
      tablePage1: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0
      },
      pagination0: {
        total: 0,
        pageSize: 10,
        currentPage: 1
      },
      multipleSelection: null,
      showCHD: false,
      checkedleft: [],
      checkAll: false,
      isIndeterminate: true,
      rcheckAll: false,
      risIndeterminate: true,
      rcheckedleft: [],
      equipmentInfo: [], // （弹出框）经销商列表
      requipmentInfo: [], // （弹出框）已选经销商列表
      pagination1: {
        total: 0,
        pageSize: 1000,
        currentPage: 1
      },
      base: {
        sectorId: null,
        provinceId: null,
        cityId: null,
        dealerName: null
      },
      selectable: {
        checkMethod: ({ row }) => {
          return !this.requipmentInfo.some(i => row.dealerId === i.dealerId)
        }
      },
      OutSelectable: {
        checkMethod: ({ row }) => {
          return !row.canisdelete > 0
        }
      },
      fileList: [],
      uploadDialog: false,
      importLoading: false,
      errorList: []
    }
  },
  watch: {},
  created() {
    console.log(this.$route,'---this.$route.----');
    console.log(this.actPlan,'----actPlan----');
    if(this.$route.params.id !== 'null') {
      this.planId = this.$route.params.id
      this.dealerFindList()
    }else {
      this.planId = this.actPlan.id
      this.dealerFindList()
    }
  },
  methods: {
    handleInput(row, field) {
      // 获取用户输入的值
      let value = row[field]
      // 移除非数字字符
      value = value.replace(/[^\d]/g, '')
      // 最大值限制为100
      if (value > 100) {
        value = 100
      }
      // 更新数据
      row[field] = value
    },
    // 查询下发活动的经销商
    dealerFindList() {
      const data = {
        page: 1,
        limit: 9999,
        planId: this.planId
      }
      this.loading1 = true
      findPlanDealers(data).then(res => {
        this.$set(this.modelTable, 'data', res.data.list)
        this.slicePlanDealers()
        this.loading1 = false
      })
    },
    // 分页
    slicePlanDealers() {
      this.loading1 = true
      setTimeout(() => {
        this.tablePage1.totalResult = this.modelTable.data.length
        this.tableData1 = this.modelTable.data.slice((this.tablePage1.currentPage - 1) * this.tablePage1.pageSize, this.tablePage1.currentPage * this.tablePage1.pageSize)
        console.log(this.tableData1,'---this.tableData1---');
        this.loading1 = false
      }, 200)
    },
    handlePageChange1({ currentPage, pageSize }) {
      this.tablePage1.currentPage = currentPage
      this.tablePage1.pageSize = pageSize
      this.slicePlanDealers()
    },
    batchInputFun() {
      this.$refs.batchInputF.validate(v => {
        if (v) {
          const data = this.modelTable.data
          // feeLimit writeRate executeFreq
          data.forEach((v, i) => {
            const obj = v
            obj.feeLimit = this.batchData.feeLimit
            obj.writeRate = this.batchData.writeRate
            obj.executeFreq = this.batchData.executeFreq
            // v.feeLimit || (obj.feeLimit = this.batchData.feeLimit)
            // v.writeRate || (obj.writeRate = this.batchData.writeRate)
            // v.executeFreq || (obj.executeFreq = this.batchData.executeFreq)
            v.customerTarget || (obj.customerTarget = this.batchData.customerTarget)
            v.orderTarget || (obj.orderTarget = this.batchData.orderTarget)
            v.executeNum || (obj.executeNum = this.batchData.executeNum)
            v.closeTime || (obj.closeTime = this.batchData.closeTime)
            this.$set(data, i, obj)
          })
          this.batchInputShow = false
          this.batchData = {}
        }
      })
    },
    handleConcatArr(selectArr, nowSelectData) {
      let arr = []
      arr = arr.concat(nowSelectData, selectArr)
      return arr
    },
    handleRemoveTabList(checkArr, originalArr) {
      for (const item of checkArr) {
        // 已保存的经销商不移除
        if (this.modelTable.data.some(i => i.id && i.dealerId === item.dealerId)) { continue }
        if (originalArr.indexOf(item) > -1) {
          this.$nextTick(() => {
            originalArr.splice(originalArr.indexOf(item), 1)
          })
        }
      }
    },
    clearData1() {
      this.base.sectorId = null
      this.base.provinceId = null
      this.base.cityId = null
      this.base.dealerName = null
      this.queryByPage1(1)
    },
    handleCheckedLeftChange(v) {
      this.checkedleft = v
      const checkedCount = v.length
      this.checkAll = checkedCount === this.equipmentInfo.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.equipmentInfo.length
    },
    rhandleCheckedLeftChange(v) {
      this.rcheckedleft = v
      const checkedCount = v.length
      this.rcheckAll = checkedCount === this.requipmentInfo.length
      this.risIndeterminate = checkedCount > 0 && checkedCount < this.requipmentInfo.length
    },
    queryByPage1(n) {
      this.modelTable.loading = true
      this.pagination1.currentPage = n
      const param = {
        page: this.pagination1.currentPage,
        limit: this.pagination1.pageSize,
        ...this.base
      }
      findDealerList(param).then(res => {
        if (res.code === 1 && res.data) {
          this.modelTable.loading = false
          this.equipmentInfo = res.data.list
          this.pagination1.total = res.data.total
        }
      })
    },
    changePage1(e) {
      if (e) {
        this.pagination1.currentPage = e.currentPage
        this.pagination1.pageSize = e.pageSize
      }
      this.queryByPage1(e.currentPage)
    },
    PutDataToRight() {
      this.requipmentInfo = this.handleConcatArr(this.requipmentInfo, this.checkedleft)
      this.$refs.table1.clearCheckboxRow() // 清空已选择
      this.checkedleft = []
    },
    PutDataToLeft() {
      this.handleRemoveTabList(this.rcheckedleft, this.requipmentInfo)
      this.$refs.table2.clearCheckboxRow() // 清空已选择
      this.rcheckedleft = []
    },
    back1() {
      this.requipmentInfo = []
      this.equipmentInfo = []
      this.showCHD = false
    },
    // 删除参与经销商
    deleteOjb() {

      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // this.$confirm('即将删除选择的数据, 是否继续?', '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() => {
        //   this.modelTable.data = this.modelTable.data.filter(val => !this.multipleSelection.some(va => va.dealerId === val.dealerId))

        //   // 获取已保存的数据，后台删除
        //   const data = this.multipleSelection.filter(val => val.id)

        //   if (data.length < 1) {
        //     return
        //   }

        //   deleteDealers(data).then(res => {
        //     if (res.code === 1) {
        //       this.$message.success('删除成功！')
        //     } else {
        //       this.$message.error(res.message)
        //     }
        //   })
        // })


        this.$confirm({
        title: '即将删除选择的数据, 是否继续?',
        content: '',
        onOk:() => {
          this.modelTable.data = this.modelTable.data.filter(val => !this.multipleSelection.some(va => va.dealerId === val.dealerId))

          console.log(this.tableData1 ,this.modelTable.data,this.multipleSelection,'--this.tableData1 = this.modelTable.data---');
          // this.tableData1 = this.modelTable.data
          // 获取已保存的数据，后台删除
          const data = this.multipleSelection.filter(val => val.dealerId)
          console.log(data,data.length,'length');

          if (data.length > 0) {
            deleteDealers(data).then(res => {
              if (res.code === 1) {
                this.$message.success('删除成功！')
                this.tableData1 = this.modelTable.data
                this.multipleSelection = []
              } else {
                this.$message.error(res.message)
              }
            })
          }
        },
        onCancel() {
          console.log('Cancel');
        },
      });
      } else {
        this.$message.error('请选择要删除的数据')
      }
    },
    // 选择参与的经销商
    handleSelectionChange(val) {
      this.multipleSelection = val.records
    },
    // 经销商列表
    goDistributorList() {
      this.btnLoading = true
      setTimeout(() => {
        this.btnLoading = false
        this.showCHD = true
        this.requipmentInfo = this.modelTable.data
        this.queryByPage1(1)
      }, 200)
    },
    submit1() {
      // feeLimit writeRate executeFreq
      // 设置初始值，，防止无法绑定
      this.requipmentInfo.forEach(v => {
        if (!v.feeLimit) v.feeLimit = null
        if (!v.writeRate) v.writeRate = null
        if (!v.executeFreq) v.executeFreq = null
      })
      this.modelTable.data = JSON.parse(JSON.stringify(this.requipmentInfo))
      this.slicePlanDealers()
      this.requipmentInfo = []
      this.equipmentInfo = []
      this.showCHD = false
    },
    // 导入弹窗
    uploadFun() {
      this.uploadDialog = true
      this.importLoading = false
      this.fileList = []
    },
    // 上传前对文件的大小的判断
    uploadBefore(file) {
      const extension = file.name.substring(file.name.lastIndexOf('.') + 1)
      console.log(extension,'---extension-----');

      const size = file.size / 1024 / 1024
      if (extension !== 'xlsx' && extension !== 'xls') {
        this.$message.error('只能上传后缀是.xlsx或者.xls的文件')
        return false
      }

      if (size > 10) {
        this.$message.error('文件大小不得超过10M')
        return false
      }
    },
    // 上传
    upload(file) {
      const formData = new FormData()
      formData.append('file', file.file)
      formData.append('planId', this.actPlan.id)
      formData.append('isPublish', '0')
      let thas = this
      this.importLoading = true
      uploadPlanDealer(formData).then(res => {
        this.importLoading = false
        if (res.code === 1) {
          this.$message.success('导入成功')
          this.$refs.upload.clearFiles()
          this.importLoading = false
          this.uploadDialog = false
          this.errorList = []
          this.dealerFindList()
        } else {
          thas.importLoading = false
          this.errorList = res.data ? res.data : []
          this.dealerFindList()
          this.$message.error(res.message)
        }
      })
    },
    // 导出经销商列表（不是活动下发对象）
    exportFun() {
      exportDealer({}).then(val => {
        this.$exportExcelData(val, `经销商列表 ${new Date().Format('yyyy年MM月DD日 HH点mm分')}.xlsx`)
      })
    },
    // 下载导入模板
    downloadTemplate() {
      exportActPlanTemp({ tempType: '1' }).then(val => {
        this.$exportExcelData(val, '活动下发对象导入模板.xlsx')
      })
    }
  }
}
</script>
<style lang="less">
.item-linew {
  margin: 0;
  padding: 0px 20px;
  width: 100%;
  background: #0a76a4;
  color: #ffffff;
  height: 30px;
  line-height: 30px;
}
.footer-btn-box {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
.move-btn-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 450px;
}
.err-box {
  margin-top: 10px;
}
</style>
